var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"loader ease-linear rounded-full border-8 border-t-8 border-gray-200",class:_vm.extraClass})])}
var staticRenderFns = []

export { render, staticRenderFns }